
export const environment = {
  production: false,
  API: {
    orchestrator_training: '/training/api/v3',
    orchestrator_configurator: '/configurator/api/v3',
    orchestrator_chat: '/chat/api/v3',
  },
  REPORT: {
    id_analytic: 'fab13f99-0061-4574-8fe8-ee05c7009b20',
    id_dashboard: '9dcc74b2-5885-4473-b7a2-9fa69d7b9c8d'
  },
  KEYCLOAK: {
    url: 'https://av-bandi-test.tellya.ai/auth',
    realm: 'aria',
    clientId: 'aria-console'
  }
};
